import TextField from "../../../../shared/TextField/TextField";

const Activity = ({ activity, isEditor, setActivities }) => (
  <TextField
    isEditor={isEditor}
    id={activity.Id}
    field="text"
    value={activity.text || ''}
    setData={setActivities}
    className={isEditor ? 'text-gray-700' : 'text-gray-600'}
  />
);

export default Activity;
